import './App.css';
import MenteeForm from './screens/MenteeForm';
import TopMentors from './screens/TopMentors';
import AllMentors from './screens/AllMentors';
import Admin from './screens/Admin';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import DefaultPage from "./screens/defaultPage";
import MainPage from "./screens/mainPage";
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import RedirectCognito from "./screens/redirectCognito";
import PhoneAndName from "./screens/phoneAndName";
import PhoneVerify from "./screens/phoneVerify";
import RefreshToken from "./screens/refreshToken";
import MentorForm from './screens/MentorForm';
import UploadImage from "./screens/uploadImage";
import BookSession from './screens/BookSession';
import SessionDetails from './screens/SessionDetails';
import UpdateSchedule from "./screens/updateSchedule";
import Sessions from "./screens/Sessions"
import PostSessionMentorForm from "./screens/PostSessionMentorForm";
import PostSessionMenteeForm from "./screens/PostSessionMenteeForm";


const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#ff9800',
    },
  },
});



function App() {

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route exact path='/' element={<DefaultPage />} />
          <Route exact path='/Main' element={<MainPage />} />
          <Route exact path='/redirectCognito' element={<RedirectCognito />} />
          <Route exact path='/refreshToken' element={<RefreshToken />} />
          <Route exact path='/menteeform' element={<MenteeForm />} />
          <Route exact path='/topmentors' element={<TopMentors />} />
          <Route exact path='/allmentors' element={<AllMentors />} />
          <Route exact path='/phone' element={<PhoneAndName />} />
          <Route exact path='/phoneverify' element={<PhoneVerify />} />
          <Route exact path='/mentorform' element={<MentorForm  />} />
          <Route exact path='/booksession' element={<BookSession  />} />
          <Route exact path='/sessiondetails' element={<SessionDetails  />} />
          <Route exact path='/uploadImage' element={<UploadImage  />} />
          <Route exact path='/updateSchedule' element={<UpdateSchedule  />} />
          <Route exact path='/sessions' element={<Sessions  />} />
          <Route exact path='/admin' element={<Admin  />} />
          <Route exact path='/postSessionMenteeForm' element={<PostSessionMenteeForm  />} />
          <Route exact path='/postSessionMentorForm' element={<PostSessionMentorForm  />} />
        </Routes>
      </Router>
    </ThemeProvider>
    
  );
}

export default App;
